"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.index-of");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.constructor");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactRouterDom = require("react-router-dom");

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("../Button"));

var _LabeledData = _interopRequireDefault(require("../LabeledData/LabeledData"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Variants = {
  REGULAR: 'REGULAR',
  COMPACT: 'COMPACT'
};

var ResultsListItem = /*#__PURE__*/function (_React$Component) {
  _inherits(ResultsListItem, _React$Component);

  var _super = _createSuper(ResultsListItem);

  function ResultsListItem() {
    var _this;

    _classCallCheck(this, ResultsListItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "renderDetailItem", function (item) {
      switch (_this.props.variant) {
        case ResultsListItem.Variants.COMPACT:
          return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
            className: "vh"
          }, item.label), /*#__PURE__*/_react.default.createElement("span", {
            title: item.label
          }, item.value));

        case ResultsListItem.Variants.REGULAR:
        default:
          return /*#__PURE__*/_react.default.createElement(_LabeledData.default, {
            term: item.label,
            definition: item.value
          });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (e) {
      var _this$props = _this.props,
          title = _this$props.title,
          handleClick = _this$props.handleClick,
          path = _this$props.path;

      if (path === null) {
        e.preventDefault(); // For desktop, pointer-events: none already does this for us. This one is for mobile
      } else {
        handleClick(title);
      }
    });

    return _this;
  }

  _createClass(ResultsListItem, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          title = _this$props2.title,
          subTitle = _this$props2.subTitle,
          detailItems = _this$props2.detailItems,
          path = _this$props2.path,
          variant = _this$props2.variant,
          iconClass = _this$props2.iconClass,
          type = _this$props2.type,
          viewDetailsButtonLabel = _this$props2.viewDetailsButtonLabel;
      var isAbsoluteUrlRegex = new RegExp('^(?:[a-z]+:)?//', 'i');
      var LinkTag = 'a';

      if (path && !isAbsoluteUrlRegex.test(path)) {
        LinkTag = _reactRouterDom.Link;
      }

      var ItemTag = variant === Variants.COMPACT ? LinkTag : 'div';
      var classes = (0, _classnames.default)('results-list-item', "results-list-item--".concat(variant.toLowerCase()), {
        'results-list-item--has-icon': !!iconClass
      });
      var optionalLinkProps = {};

      if (type && type.toLowerCase().indexOf('pdf') !== -1) {
        optionalLinkProps.target = '_blank';
        optionalLinkProps.rel = 'noopener noreferrer';
      } else {
        optionalLinkProps.download = 'download';
      }

      return /*#__PURE__*/_react.default.createElement(ItemTag, _extends({
        to: path === null ? '' : path,
        href: path === null ? '' : path,
        disabled: path === null,
        className: classes,
        onClick: this.handleClick
      }, optionalLinkProps), /*#__PURE__*/_react.default.createElement("div", {
        className: "__title"
      }, iconClass && /*#__PURE__*/_react.default.createElement("span", {
        className: "icon ".concat(iconClass)
      }), title), subTitle && /*#__PURE__*/_react.default.createElement("div", {
        className: "__subtitle"
      }, subTitle), detailItems && detailItems.length > 0 && /*#__PURE__*/_react.default.createElement("ul", {
        className: "__detail-list"
      }, detailItems.map(function (item, i) {
        return /*#__PURE__*/_react.default.createElement("li", {
          key: item.key || i
        }, _this2.renderDetailItem(item));
      })), variant === Variants.REGULAR && /*#__PURE__*/_react.default.createElement(_Button.default, _extends({
        variant: _Button.default.Variant.PRIMARY,
        tag: LinkTag
      }, LinkTag === 'a' ? {
        href: path
      } : {
        to: path
      }), viewDetailsButtonLabel));
    }
  }], [{
    key: "Variants",
    get: function get() {
      return Variants;
    }
  }]);

  return ResultsListItem;
}(_react.default.Component);

exports.default = ResultsListItem;

_defineProperty(ResultsListItem, "defaultProps", {
  title: null,
  subTitle: null,
  detailItems: [],
  path: '',
  variant: Variants.COMPACT,
  type: null,
  iconClass: null,
  viewDetailsButtonLabel: null,
  handleClick: function handleClick() {}
});

_defineProperty(ResultsListItem, "propTypes", {
  title: _propTypes.default.node,
  subTitle: _propTypes.default.node,
  variant: _propTypes.default.string,
  detailItems: _propTypes.default.arrayOf(_propTypes.default.shape({
    label: _propTypes.default.node,
    value: _propTypes.default.node
  })),
  path: _propTypes.default.string,
  type: _propTypes.default.string,
  iconClass: _propTypes.default.string,
  viewDetailsButtonLabel: _propTypes.default.string,
  handleClick: _propTypes.default.func
});
//# sourceMappingURL=ResultsListItem.js.map